import { BarChart, Building, Flame, ScrollText, Activity } from 'lucide-vue-next';
import { UserRoles } from '@/shared/models/UserRoles';

export interface AdminOption {
  title: string
  toolTip: string
  icon: any
  class: string
  href: string
  roles?: string[]
}

export const adminOptions: AdminOption[] = [
  
  {
    title: 'Usage',
    toolTip: "View User & Tenant Metrics",
    icon: BarChart,
    class: 'large-button',
    href: '/app/administration/tenant-metrics',
  },
  {
    title: 'Tenant',
    toolTip: 'Tenant Administration',
    icon: Building,
    class: 'large-button',
    href: '/app/administration/tenant-management',
  },
  {
    title: 'Lambda Warm-Up',
    toolTip: 'Lambda Warm-Up Status & Schedule',
    icon: Flame,
    class: 'large-button',
    href: '/app/administration/warm-up',
    roles: [UserRoles.PlatformAdmin, UserRoles.PlatformDeveloper],
  },
  {
    title: 'Audit Logs',
    toolTip: 'View Audit Logs',
    icon: ScrollText,
    class: 'large-button',
    href: '/app/administration/audit-logs',
    roles: [UserRoles.PlatformAdmin, UserRoles.PlatformAuditor, UserRoles.TenantAdmin, UserRoles.TenantAuditor],
  },
  {
    title: 'Diagnostics',
    toolTip: 'Execution Diagnostics Timeline',
    icon: Activity,
    class: 'large-button',
    href: '/app/administration/diagnostics',
    roles: [UserRoles.PlatformAdmin, UserRoles.PlatformDeveloper],
  },
];


